import * as React from "react";
import {ErlButtonBigRed} from "../ErlButtonBigRed";
import '../../../../css/react-partner-portal-login.css';
import {ErlButtonBig} from "../ErlButtonBig";

interface PartnerPortalLoginProps {

}

export default function PartnerPortalLogin(props: PartnerPortalLoginProps) {

    return <div className={"erl-partner-login"}>
        <div className={"erl-partner-login-header"}>
            <img alt={''} src="/wp-content/plugins/erlbau/images/logo-partner-portal.svg"/>
        </div>

        <div className={"erl-partner-login-content"}>
            <div className={"partner-login-label partner-login-label-first"}>Als bestehender Partner</div>
            <a href={"/partnerportal"}>
                <ErlButtonBig className={'arrow-button'} label={"Einloggen"}></ErlButtonBig>
            </a>

            <div className={"partner-login-label"}>Als neuer Partner</div>

            <a href={"#partner-werden"}>
            <ErlButtonBigRed className={"avia-button avia-icon_select-no avia-color-dark avia-size-medium alternate-color become-partner"} label={"Jetzt Partner werden"}></ErlButtonBigRed>
            </a>
        </div>
    </div>
}